export default __webpack_public_path__ + "static/media/avatar.9d7c3fe2.png";